document.addEventListener('change', (event) => {
  const input = event.target;
  if (!input.classList || !input.classList.contains('swatch-input__input')) return;
  const formId = input.getAttribute('form');
  const data = formId && document.querySelector(`script[data-card-variants="${formId}"]`);
  const form = formId && document.getElementById(formId);
  if (!data || !form) return;
  const variant = JSON.parse(data.textContent).find((v) => v.option === input.value);
  if (!variant) return;
  const idInput = form.querySelector('input[name="id"]');
  const button = form.querySelector('button[name="add"]');
  idInput.value = variant.id;
  idInput.disabled = !variant.available;
  if (button) {
    button.disabled = !variant.available;
    const label = button.querySelector('span');
    if (label) label.textContent = variant.available ? window.variantStrings?.addToCart || 'Add to cart' : window.variantStrings?.soldOut || 'Sold out';
  }
});
